export const referencesPerPage = 12;

export const referencesInclude = 'products';
